import request from "./request";

export async function postMessage(body) {
  return request.post("/api/message", body);
}

export async function getMessage(page = 1, limit = 10) {
  return request.get("/api/message", {
    params: {
      page,
      limit,
    },
  });
}

